export const view04ImageOptions = {
  angle: 'view04',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    TeakOnCoachroof: 1,
    SprayHoodVersion: 1,
    SprayHood: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'HullTreatment',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X46/views/view04.js